var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { manageService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var PrincipalService = /** @class */ (function (_super) {
    __extends(PrincipalService, _super);
    function PrincipalService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 新增委托方
     */
    PrincipalService.prototype.addPrincipal = function (data, loading) {
        return this.netService.send({
            server: manageService.principalController.addPrincipal,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改委托方
     */
    PrincipalService.prototype.modifyPrincipal = function (data, loading) {
        return this.netService.send({
            server: manageService.principalController.modifyPrincipal,
            data: data,
            loading: loading
        });
    };
    /**
     * 多条件查询委托方
     */
    PrincipalService.prototype.findAllPrincipal = function (data, page, sort, loading) {
        return this.netService.send({
            server: manageService.principalController.findAllPrincipal,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 查询全部委托方
     */
    PrincipalService.prototype.findAllPrincipalNoPage = function (loading) {
        return this.netService.send({
            server: manageService.principalController.findAllPrincipalNoPage,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], PrincipalService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], PrincipalService.prototype, "addPrincipal", null);
    __decorate([
        Debounce()
    ], PrincipalService.prototype, "modifyPrincipal", null);
    __decorate([
        Debounce()
    ], PrincipalService.prototype, "findAllPrincipal", null);
    __decorate([
        Debounce()
    ], PrincipalService.prototype, "findAllPrincipalNoPage", null);
    return PrincipalService;
}(Service));
export { PrincipalService };
